import api from '@/api';

export const thicknessInterlayerModel = {
    state: {
        data: {},
        error: false,
        loading: false,
    },
    reducers: {
        setThicknessInterlayer: (state, payload) => {
            return { ...state, data: { ...state.data, [payload.id]: payload.data } };
        },
        setError: (state, payload) => {
            return { ...state, error: payload };
        },
    },
    effects: dispatch => ({
        async loadThicknessInterlayer(wellId, rootState) {
            try {
                const data = await api.carottage.fetchThicknessInterlayer({
                    wellIds: [wellId],
                });

                // const res = {};

                // data.forEach(u => {
                //     if (!res[u.well_id]) {
                //         res[u.well_id] = [u];
                //     } else {
                //         res[u.well_id] = [...res[u.well_id], u];
                //     }
                // });

                this.setThicknessInterlayer({ id: wellId, data: data });
            } catch (error) {
                this.setError(error);
            }
        },
    }),
};
